var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eIzNwrvtxoZ1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 18,
    height: 18,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,14.5h5.3c.8,1,2,1.6,3.3,1.6c2.4,0,4.3-1.9,4.3-4.3c0,0,0,0,0,0c0-1.4-.7-2.8-1.9-3.6v-4c0-.7-.6-1.2-1.3-1.2h-1v-.8c0-.1-.1-.2-.2-.3c0,0,0,0-.1,0h-1.5c-.2,0-.3.1-.3.3v.8h-3.5v-.8c0-.2-.2-.3-.4-.3h-1.4c-.2,0-.4.1-.4.3v.8h-1c-.6,0-1.2.5-1.2,1.2v9.1c0,.7.6,1.2,1.3,1.2Zm12.2-2.7c0,2-1.7,3.7-3.7,3.6-2,0-3.7-1.7-3.6-3.7c0-2,1.6-3.6,3.7-3.6c2,0,3.6,1.7,3.6,3.7c0,0,0,0,0,0ZM11.8,7.5c-2.4,0-4.3,1.9-4.3,4.2c0,0,0,0,0,0c0,.7.2,1.4.5,2.1h-4.8c-.3,0-.6-.2-.6-.5v-6.5h11v1.1c-.6-.3-1.2-.4-1.8-.4ZM10.4,2.6h.8v1.4h-.8v-1.4Zm-5.6,0h.9v1.4h-.9v-1.4ZM3.2,3.7h1v.6c0,.2.1.3.3.3h1.5c.2,0,.3-.2.4-.3v-.6h3.4v.6c0,.2.1.3.3.3h1.5c.2,0,.3-.2.3-.3v-.6h1c.3,0,.7.2.7.5v2h-11v-2c0-.3.2-.5.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,9.9v2.2c0,.2.2.3.4.3h1.7c.2,0,.3-.1.3-.3s-.1-.3-.3-.3h-1.4v-1.9c0-.2-.1-.3-.3-.3s-.4.2-.4.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditSchedule);
export default __webpack_public_path__ + "static/media/Audit-schedule.3565dc4861bc8f0e386cc3f152a7afda.svg";
export { ForwardRef as ReactComponent };